import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import { ExpertsList, PartnersList } from "@/pages/Experts";
import { ExpertProfile, PartnerProfile } from "@/pages/Profiles";
import { Shop, ProductDetail, Cart } from "@/pages/Shop";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import { JoinExpert, JoinPartner } from "@/pages/Join";
import Dashboard from "@/pages/Dashboard";
import AdminPanel from "@/pages/Admin";
import { Profile, StaticPage } from "@/pages/Profile";
import { Messages, Conversation } from "@/pages/Messages";
import { ResourcesHub, ResourceList, ResourceDetail, FAQsPage, LegalPage } from "@/pages/Resources";
import { About, Contact } from "@/pages/Site";

function Layout({ children }) {
  return (
    <div className="App">
      <Header />
      <main>{children}</main>
      <Footer />
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#080D14", border: "1px solid rgba(255,255,255,0.08)", color: "#F8FAFC" } }} />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/experts" element={<ExpertsList />} />
              <Route path="/experts/designers" element={<Navigate to="/experts?category=Designer" replace />} />
              <Route path="/experts/printing-partners" element={<PartnersList />} />
              <Route path="/experts/printing-partners/:slug" element={<PartnerProfile />} />
              <Route path="/experts/:slug" element={<ExpertProfile />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/shop/product/:slug" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/join/expert" element={<JoinExpert />} />
              <Route path="/join/partner" element={<JoinPartner />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/messages" element={<Messages />} />
              <Route path="/messages/:cid" element={<Conversation />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/resources" element={<ResourcesHub />} />
              <Route path="/resources/blog" element={<ResourceList type="blog" />} />
              <Route path="/resources/guides" element={<ResourceList type="guide" />} />
              <Route path="/resources/tutorials" element={<ResourceList type="tutorial" />} />
              <Route path="/resources/faqs" element={<FAQsPage />} />
              <Route path="/resources/:slug" element={<ResourceDetail />} />
              <Route path="/legal/:slug" element={<LegalPage />} />
              <Route path="*" element={<StaticPage title="Not Found"><p>The page you're looking for doesn't exist.</p></StaticPage>} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </AuthProvider>
  );
}
